import React from "react"
import EngineIDNavBar from "@components/EngineIDNavBar"
import Banner from "./Banner"
import SectionOne from "./SectionOne"
import WeBelieve from "./WeBelieve"
import CTASignUpLong from "@components/CTASignUpLong"
import Footer from "@components/Footer"
import "./index.scss"
import "@styles/global.scss"

const WhoWeAre = props => {
  return (
    <div>
      <EngineIDNavBar />
      <Banner />
      <div className={"container-fluid"}>
        <div className={"maxWidth"}>
          <SectionOne></SectionOne>
          <WeBelieve></WeBelieve>
        </div>
      </div>
      <CTASignUpLong />
      <Footer />
    </div>
  )
}

export default WhoWeAre
